// client/src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import { AdvertiserProvider } from "./contexts/AdvertiserContext";
import { BrowserRouter } from "react-router-dom";
import "./components/GlobalLuminanceCalibration.css";

// Support CRA + Vite
const DEFAULT_PRODUCTION_BACKEND_URL = "https://cphere-backend.onrender.com";
const API_BASE_URL =
  process.env.REACT_APP_BACKEND_URL ||
  (process.env.NODE_ENV === "production" ? DEFAULT_PRODUCTION_BACKEND_URL : "");

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <AdvertiserProvider apiBaseUrl={API_BASE_URL}>
          <App />
        </AdvertiserProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
